import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IsRunningOverwolf } from "utilityFunctions";
import backArrow from "../../assets/svg/arrow-black.svg";

export const LoginAndSignupButtons = () => {
  const params = useParams<{ qrTokenToValidate: string }>();
  const { t } = useTranslation();
  const language = t("localization_testing");
  const isRunningOverwolf = IsRunningOverwolf();

  return (
    <div
      className={`${
        language === "fr" ? "sm:space-x-6 sm:pl-4" : "sm:space-x-2"
      } ${
        isRunningOverwolf ? "justify-between" : ""
      } text-slate-200 flex text-sm font-semibold`}
    >
      <Link
        to={`/login${
          params.qrTokenToValidate ? `/${params.qrTokenToValidate}` : ""
        }`}
        draggable={false}
      >
        <button className="w-24 2xl:w-28 py-2 px-2 lg:px-4 hover:opacity-70 transition duration-300 ease-in-out">
          <span className="2xl:text-base">{t("form.login")}</span>
        </button>
      </Link>
      <Link
        to={`/signup${
          params.qrTokenToValidate ? `/${params.qrTokenToValidate}` : ""
        }`}
        draggable={false}
      >
        <button
          className="py-2 px-3 lg:px-4 whitespace-nowrap rounded-2xl bg-[#87FCF7] bg-opacity-70 hover:bg-opacity-50 transition duration-300 ease-in-out flex justify-center lg:justify-between items-center text-slate-900 space-x-2 lg:space-x-3"
          id="Sign-Up-For-Free"
        >
          <span className="hidden lg:block 2xl:text-base" id="Sign-Up-For-Free">
            {t("landingPage.signUpForFree")}
          </span>
          <span className="lg:hidden" id="Sign-Up-For-Free">
            {t("form.signUp")}
          </span>
          <img className="rotate-180 h-3" src={backArrow} alt="Back Arrow" />
        </button>
      </Link>
    </div>
  );
};
